import { Component } from '@angular/core';

@Component({
	selector: 'seira-sem-permissao',
	templateUrl: './sem-permissao.component.html',
	styleUrls: ['./sem-permissao.component.scss'],
})
export class SemPermissaoComponent {}
